import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import config from '@/config'
const title = config.title

const router = new Router({
  mode: 'history',
  base: '/tongitspinoy',
  routes: [
    {
      path: '*',
      redirect: "/"
    },
    {
      path: "/",
      name: 'TongitSpinoy',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '',
          redirect: 'home'
        },
        {
          path: 'home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: title + '-Home'
          }
        },
        {
          path: 'legal',
          name: 'Legal',
          component: resolve => require(['@/view/Legal'], resolve),
          meta: {
            title: title + '-Legal'
          },
          children: [
            {
              path: 'termService',
              name: 'Term of Service',
              component: resolve => require(['@/view/TermService'], resolve),
              meta: {
                title: title + '-Term of Service'
              }
            },
            {
              path: 'privacyPolicy',
              name: 'Privacy Policy',
              component: resolve => require(['@/view/PrivacyPolicy'], resolve),
              meta: {
                title: title + '-Privacy Policy'
              }
            },
            {
              path: 'cookiePolicy',
              name: 'Cookie Policy',
              component: resolve => require(['@/view/CookiePolicy'], resolve),
              meta: {
                title: title + '-Cookie Policy'
              }
            },
            {
              path: 'refundPolicy',
              name: 'Refund Policy',
              component: resolve => require(['@/view/RefundPolicy'], resolve),
              meta: {
                title: title + '-Refund Policy'
              }
            }
          ]
        },
        {
          path: 'contactUs',
          name: 'Contact Us',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: title + '-Contact Us'
          }
        }
      ]
    }
  ]
});

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js